import React from 'react';
import PaginaNoEncontrada from "./components/PaginaNoEncontrada";
import Footer from './components/Footer';
import Home from './components/Home';
import Cursos from "./components/Cursos";
import Tareas from "./components/Tareas";
import Alumno from "./components/Alumno";
import NavBar from './components/NavBar';
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContextProvider from './context/ContextProvider';

function App() {
  return (
    <>
    <BrowserRouter>
    <ContextProvider>
        <NavBar />
        <Routes>
                        <Route path="/" element={<Home/>} />
                        <Route path="/cursos" element={<Cursos />} />
                        <Route path="/cursos/:cursoId" element={<Cursos />} />
                        <Route path="/tareas/" element={<Tareas />} />
                        <Route path="/alumno/" element={<Alumno/>} />
                        <Route path="/alumno/:alumnoId" element={<Alumno/>}/>
                        <Route path="*" element={<PaginaNoEncontrada />} />
        </Routes>
    </ContextProvider>
    <Footer />
    <ToastContainer />
    </BrowserRouter>
    </>
)}

export default App;
